import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

export function datefmtMilliSecondFn() {
  const currentDate = new Date()
  const year = currentDate.getFullYear()
  const month = String(currentDate.getMonth() + 1).padStart(2, '0')
  const day = String(currentDate.getDate()).padStart(2, '0')
  const hours = String(currentDate.getHours()).padStart(2, '0')
  const minutes = String(currentDate.getMinutes()).padStart(2, '0')
  const seconds = String(currentDate.getSeconds()).padStart(2, '0')
  const milliseconds = String(currentDate.getMilliseconds()).padStart(3, '0')
  const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`
  console.log(formattedTime)

  return formattedTime
}

export const citationRegex = /\[\^(\d+)\^\]/g
export const citationSupRegex = /<sup>\[(\d+)\]<\/sup>/g

function convertQuotesToEntities(str: string) {
  str = str.replace(/'/g, '&apos;')
  str = str.replace(/"/g, '&quot;')
  return str
}

export function removeCitations(content: string) {
  const citationRegex = /:citation\[[^\]]*\]\{[^}]*\}/g
  return content.replace(citationRegex, '')
}

export function toCitationDirective(
  content: string,
  citation: Array<{
    title: string
    url: string
    snippet: string
    link?: string
  }>,
  regex = citationRegex,
) {
  const result = content.replaceAll(regex, (match, index) => {
    const curCitation = citation[parseInt(index) - 1]
    // console.log('replaceAll =>', { match, index, curCitation })

    if (curCitation) {
      const text = `:citation[${index}]{href='${
        curCitation.url || curCitation.link
      }' title='${convertQuotesToEntities(
        encodeURIComponent(curCitation.title),
      )}' snippet='${convertQuotesToEntities(
        encodeURIComponent(curCitation.snippet),
      )}'}`
      return text
    } else {
      return ''
    }
  })
  return result
}

export function convertSize(sizeBytes: number) {
  if (sizeBytes === 0) return '0 B'

  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(sizeBytes) / Math.log(1024))
  const size = sizeBytes / 1024 ** i

  return `${size.toFixed(2)} ${units[i]}`
}

export function durationTs(milliseconds: number, format = 'HH:mm:ss') {
  return dayjs.duration(milliseconds).format(format)
}

export function datefmtFn(
  date?: string | Date | number,
  format = 'YYYY-MM-DD',
) {
  return dayjs(date).format(format)
}
